module.exports = __webpack_public_path__ + "img/logo.1d4c4d6f.png";